import { isSuccess } from "@dgs/core";
import { FC, useCallback } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useRegion } from "../../region/RegionProvider";
import { mapConsentValuesToBody } from "../../registration/registrationFormUtils";
import { registrationFormService } from "../../shared/api/registrationForms";
import {
	RegistrationFormEmailGateRequest,
	RegistrationFormEmailGateResult,
	RegistrationFormResource,
} from "../../shared/types/registrationForm";
import { EmailGateForm, EmailGateFormValues } from "./EmailGateForm";
import { EmailGateInvitedPage } from "./EmailGateInvitedPage";
import { EmailGateWelcomeBackPage } from "./EmailGateWelcomeBackPage";

interface Props {
	registrationForm: RegistrationFormResource;
}

export const EmailGatePage: FC<Props> = ({ registrationForm }) => {
	const navigate = useNavigate();
	const { regionId } = useRegion();

	const handleSubmit = useCallback(
		async (values: EmailGateFormValues) => {
			const request: RegistrationFormEmailGateRequest = {
				email: values.email,
				consents: mapConsentValuesToBody(values.consents),
				regionId: regionId,
			};
			const response = await registrationFormService.submitEmailGate(registrationForm.id, request);
			if (!isSuccess(response)) {
				return;
			}
			const resource = response.data.data;
			switch (resource.result) {
				case RegistrationFormEmailGateResult.WELCOME_BACK:
					navigate("../welcome-back");
					break;
				case RegistrationFormEmailGateResult.INVITED:
					navigate("../invited");
					break;
				case RegistrationFormEmailGateResult.CONTINUE:
					navigate({ search: `token=${resource.token}` }, { replace: true });
					break;
			}
		},
		[navigate, regionId, registrationForm.id],
	);

	return (
		<Routes>
			<Route index path="*" element={<EmailGateForm registrationForm={registrationForm} onSubmit={handleSubmit} />} />
			<Route path="welcome-back" element={<EmailGateWelcomeBackPage registrationForm={registrationForm} />} />
			<Route path="invited" element={<EmailGateInvitedPage registrationForm={registrationForm} />} />
		</Routes>
	);
};
